module.exports = __webpack_public_path__ + "static/media/instantPolicies@2x.efd03b1f.jpg";